import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a0d926ee")

_pushScopeId("data-v-a0d926ee")
const _hoisted_1 = {
  key: 0,
  style: {"white-space":"nowrap","overflow":"hidden","vertical-align":"top"}
}
const _hoisted_2 = {
  key: 0,
  class: "inline list nozzle-color-selection"
}
const _hoisted_3 = { style: {"height":"100%"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Select Color", -1)
const _hoisted_5 = {
  key: 0,
  class: "display-flex align-items-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_store_list_item = _resolveComponent("store-list-item")
  const _component_f7_list_group = _resolveComponent("f7-list-group")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_accordion_content = _resolveComponent("f7-accordion-content")
  const _component_f7_list_input = _resolveComponent("f7-list-input")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.getJets.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_f7_list, {
            "accordion-list": "",
            class: "inline",
            style: _ctx.readonly ? 'width: 100%' : 'width: calc(100% - 170px)'
          }, {
            default: _withId(() => [
              _createVNode(_component_f7_list_item, {
                "accordion-item": "",
                title: "Jet Heads"
              }, {
                media: _withId(() => [
                  _createVNode("div", {
                    class: "jet-image",
                    style: `background-image: url('${_ctx.getJets[0].imageUrl}')`
                  }, null, 4)
                ]),
                default: _withId(() => [
                  _createVNode(_component_f7_accordion_content, null, {
                    default: _withId(() => [
                      _createVNode(_component_f7_list, null, {
                        default: _withId(() => [
                          (_ctx.filterByPackageType && _ctx.getJetsPlumbingRoughInItems.length > 0)
                            ? (_openBlock(), _createBlock(_component_f7_list_group, { key: 0 }, {
                                default: _withId(() => [
                                  _createVNode(_component_f7_list_item, {
                                    title: "Plumbing Rough In",
                                    "group-title": ""
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getJetsPlumbingRoughInItems, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_store_list_item, {
                                      readonly: _ctx.readonly,
                                      "show-price": _ctx.showPrice,
                                      key: 'jet-item-rough-' + i,
                                      item: item
                                    }, null, 8, ["readonly", "show-price", "item"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.filterByPackageType && _ctx.getJetsTrimAndStartUpItems.length > 0)
                            ? (_openBlock(), _createBlock(_component_f7_list_group, { key: 1 }, {
                                default: _withId(() => [
                                  _createVNode(_component_f7_list_item, {
                                    title: "Trim and Start Up",
                                    "group-title": ""
                                  }),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getJetsTrimAndStartUpItems, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_store_list_item, {
                                      readonly: _ctx.readonly,
                                      "show-price": _ctx.showPrice,
                                      key: 'jet-item-trim-' + i,
                                      item: item
                                    }, null, 8, ["readonly", "show-price", "item"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.getOtherJetsItems.length > 0)
                            ? (_openBlock(), _createBlock(_component_f7_list_group, { key: 2 }, {
                                default: _withId(() => [
                                  (_ctx.filterByPackageType)
                                    ? (_openBlock(), _createBlock(_component_f7_list_item, {
                                        key: 0,
                                        title: _ctx.otherJetsTitle,
                                        "group-title": ""
                                      }, null, 8, ["title"]))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getOtherJetsItems, (item, i) => {
                                    return (_openBlock(), _createBlock(_component_store_list_item, {
                                      readonly: _ctx.readonly,
                                      "show-price": _ctx.showPrice,
                                      key: 'jet-item-other-' + i,
                                      item: item
                                    }, null, 8, ["readonly", "show-price", "item"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("ul", _hoisted_3, [
                  _createVNode(_component_f7_list_input, {
                    class: "height-offset",
                    readonly: _ctx.readonly,
                    outline: "",
                    type: "select",
                    value: _ctx.itemColor,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.itemColor = $event))
                  }, {
                    default: _withId(() => [
                      _hoisted_4,
                      _createVNode("option", {
                        value: "W",
                        disabled: _ctx.readonly
                      }, "White", 8, ["disabled"]),
                      _createVNode("option", {
                        value: "LG",
                        disabled: _ctx.readonly
                      }, "Light Grey", 8, ["disabled"]),
                      _createVNode("option", {
                        value: "DG",
                        disabled: _ctx.readonly
                      }, "Dark Grey", 8, ["disabled"]),
                      _createVNode("option", {
                        value: "BL",
                        disabled: _ctx.readonly
                      }, "Black", 8, ["disabled"]),
                      _createVNode("option", {
                        value: "BE",
                        disabled: _ctx.readonly
                      }, "Beige", 8, ["disabled"]),
                      _createVNode("option", {
                        value: "LB",
                        disabled: _ctx.readonly
                      }, "Light Blue", 8, ["disabled"])
                    ]),
                    _: 1
                  }, 8, ["readonly", "value"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_f7_list, {
      "dividers-ios": "",
      "strong-ios": "",
      "outline-ios": "",
      class: "cart-list no-margin"
    }, {
      default: _withId(() => [
        (_ctx.filterByPackageType && _ctx.getPlumbingRoughInItems.length > 0)
          ? (_openBlock(), _createBlock(_component_f7_list_group, { key: 0 }, {
              default: _withId(() => [
                _createVNode(_component_f7_list_item, {
                  title: "Plumbing Rough In",
                  "group-title": ""
                }),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPlumbingRoughInItems, (item, i) => {
                  return (_openBlock(), _createBlock(_component_store_list_item, {
                    readonly: _ctx.readonly,
                    "show-price": _ctx.showPrice,
                    key: 'bom-item-rough-' + i,
                    item: item
                  }, null, 8, ["readonly", "show-price", "item"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.filterByPackageType && _ctx.getTrimAndStartUpItems.length > 0)
          ? (_openBlock(), _createBlock(_component_f7_list_group, { key: 1 }, {
              default: _withId(() => [
                _createVNode(_component_f7_list_item, {
                  title: "Trim and Start Up",
                  "group-title": ""
                }),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getTrimAndStartUpItems, (item, i) => {
                  return (_openBlock(), _createBlock(_component_store_list_item, {
                    readonly: _ctx.readonly,
                    "show-price": _ctx.showPrice,
                    key: 'bom-item-trim-' + i,
                    item: item
                  }, null, 8, ["readonly", "show-price", "item"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.getOtherBomItems.length > 0)
          ? (_openBlock(), _createBlock(_component_f7_list_group, { key: 2 }, {
              default: _withId(() => [
                (_ctx.filterByPackageType)
                  ? (_openBlock(), _createBlock(_component_f7_list_item, {
                      key: 0,
                      title: _ctx.otherBomItemsTitle,
                      "group-title": ""
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getOtherBomItems, (item, i) => {
                  return (_openBlock(), _createBlock(_component_store_list_item, {
                    readonly: _ctx.readonly,
                    "show-price": _ctx.showPrice,
                    key: 'bom-item-other-' + i,
                    item: item
                  }, null, 8, ["readonly", "show-price", "item"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.hideSubtotal)
          ? (_openBlock(), _createBlock(_component_f7_list_item, {
              key: 3,
              title: "Subtotal",
              footer: _ctx.items.length + ' items'
            }, {
              after: _withId(() => [
                (_ctx.showPrice)
                  ? (_openBlock(), _createBlock("h3", _hoisted_5, _toDisplayString(_ctx.subtotal), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["footer"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
})